module.exports = __webpack_public_path__ + "assets/skype1.604cdf71.svg";